interface LoadingSpinnerProps {
  fullScreen?: boolean;
  message?: string;
}

export function LoadingSpinner({
  fullScreen = false,
  message,
}: LoadingSpinnerProps) {
  const spinner = (
    <div role="status" className="flex flex-col items-center justify-center gap-3 rounded-[20px] border border-dashed border-border bg-card px-5 py-7">
      <div aria-hidden="true" className="w-full gap-x-2 flex justify-center items-center">
        <div className="size-2 rounded-full bg-primary/80 motion-safe:animate-pulse" />
        <div className="size-2 rounded-full bg-primary motion-safe:animate-pulse" />
        <div className="size-2 rounded-full bg-primary/50 motion-safe:animate-pulse" />
      </div>

      {message ? <p className="text-sm text-muted-foreground">{message}</p> : <span className="sr-only">Loading...</span>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        {spinner}
      </div>
    );
  }

  return spinner;
}
